(function(){
  "use strict";

  function getParam(name){
    return new URLSearchParams(window.location.search).get(name);
  }

  function fillByPlaceholder(placeholder, value){
    if(!value) return false;
    var el = document.querySelector(
      'input[placeholder="' + placeholder + '"], textarea[placeholder="' + placeholder + '"]'
    );
    if(!el) return false;
    // React/Easify über nativen Setter triggern
    var proto = el.tagName === "TEXTAREA"
      ? window.HTMLTextAreaElement.prototype
      : window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, "value").set;
    setter.call(el, value);
    el.dispatchEvent(new Event("input",  {bubbles:true}));
    el.dispatchEvent(new Event("change", {bubbles:true}));
    el.style.transition = "box-shadow .3s ease";
    el.style.boxShadow  = "0 0 0 3px rgba(224,162,75,.55)";
    setTimeout(function(){ el.style.boxShadow = ""; }, 2200);
    return true;
  }

  function showBanner(){
    var el = document.querySelector(
      'input[placeholder="Trage hier die gewünschte Adresse oder die Koordinaten deines Ortes ein"]'
    );
    if(!el) return;
    var banner = document.createElement("div");
    banner.setAttribute("role", "status");
    banner.style.cssText = "margin:12px 0 4px;padding:10px 14px;border-radius:10px;"
      + "background:rgba(224,162,75,.12);border:1px solid rgba(224,162,75,.4);"
      + "font-size:13.5px;color:#5C4E3F;line-height:1.5";
    banner.innerHTML = "✦ <strong>Deine Kartendaten wurden übernommen</strong>"
      + " — bitte überprüfe die Felder unten und passe sie bei Bedarf an.";
    var parent = el.closest("[class*='easify']") || el.parentElement;
    if(parent && parent.parentElement) parent.parentElement.insertBefore(banner, parent);
    setTimeout(function(){
      banner.style.transition = "opacity .6s";
      banner.style.opacity = "0";
      setTimeout(function(){ banner.remove(); }, 700);
    }, 5000);
  }

  function run(adresse, rahmen, attempt){
    attempt = attempt || 1;
    var ok1 = fillByPlaceholder(
      "Trage hier die gewünschte Adresse oder die Koordinaten deines Ortes ein",
      adresse
    );
    var ok2 = !rahmen || fillByPlaceholder(
      "Trage hier ein was oben und unten auf dem Rahmen stehen soll",
      rahmen
    );

    if(ok1 && ok2){
      showBanner();
      return;
    }
    if(attempt < 15){
      setTimeout(function(){ run(adresse, rahmen, attempt + 1); }, 400);
    }
  }

  function init(){
    var adresse = getParam("lk_adresse");
    var rahmen  = getParam("lk_rahmen");
    if(!adresse && !rahmen) return;
    setTimeout(function(){ run(adresse, rahmen, 1); }, 800);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();